const courses = {
  title: "Kurs",
  name: "Navn",
  coursetype: "Kompetanse",
  coursetemplate: "Kursmal",
  class: "Klasse",
  instructor: "Instruktør",
  classroom: "Klasserom",
  address: "Adresse",
  start: "Start",
  start_date: "Start dato",
  start_time: "Start tid",
  end: "Slutt",
  end_date: "slutt dato",
  end_time: "slutt tid",
  enrolled_date: "Påmeldt",
  theory_test: "Teoritest",
  met_up_days: "Oppmøte",
  type: "Type",
  course_completed: "Kurs fullført",
  completed: "Fullført",
  ongoing: "Pågår",
  status: "Status",
  diploma: "Kursbevis",
  organisation: "Opplæringsvirksomhet",
}
export default courses
